import Popper from '@material-ui/core/Popper';
import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import { useCompleteListPagination } from '@/src/hooks/useListCompletePagination';

import TaskItem from './TaskItem/TaskItem';

const CREATE_TASK_LIST_LIMIT = 5;

const CreateTaskList = ({ taskList, open, anchorEl, onShowCreateTaskModal, onOpenTask }) => {
  const {
    loadMore,
    hasMore,
    paginatedList: paginatedTaskList,
  } = useCompleteListPagination({
    list: taskList,
    maxPerPage: CREATE_TASK_LIST_LIMIT,
  });

  return (
    <Popper open={open} anchorEl={anchorEl} placement="left-start" style={{ zIndex: 100 }}>
      <div
        className={clsx(
          'inboxTasks--container',
          'tw-min-w-[321px] tw-w-full',
          'tw-bg-white tw-shadow-[3px_4px_5px_rgba(0,0,0,0.06)]',
          'tw-border-solid tw-border-[1px] tw-border-cfo-grey-500 tw-rounded-b-[5px]',
          'tw-p-0 tw-ml-[-25px]'
        )}
      >
        <div className="actionItem">
          <Button
            className={clsx(
              'tw-w-full',
              'tw-py-[6px]',
              'hover:tw-bg-cfo-blue-200 hover:tw-font-brandonTextMedium'
            )}
            buttonClassSettings={{
              variant: 'style_unset',
              size: 'sm',
              position: 'left',
            }}
            onClick={onShowCreateTaskModal}
          >
            Create Task
          </Button>
        </div>
        <div
          className={clsx(
            'inboxItemsList--container',
            'tw-max-h-[225px] tw-h-auto',
            'tw-overflow-y-auto tw-overflow-x-hidden tw-scroll-styles'
          )}
        >
          {paginatedTaskList.map((task) => (
            <TaskItem key={`ti_${task.id}`} task={task} onOpenTask={onOpenTask} />
          ))}
          {hasMore && (
            <Button
              className={clsx(
                'tw-w-full',
                'tw-text-cfo-blue-600',
                'tw-py-[6px]',
                'hover:tw-underline hover:tw-bg-cfo-blue-200'
              )}
              buttonClassSettings={{
                variant: 'style_unset',
                size: 'sm',
                weight: 'bold',
                position: 'left',
              }}
              onClick={loadMore}
            >
              Load More
            </Button>
          )}
        </div>
      </div>
    </Popper>
  );
};

export default CreateTaskList;
